import { adminApi } from "./adminClient";

// Bestaande beheerders
export const fetchAdminUsers = async () => {
  const r = await adminApi.get("/admin/users");
  return r.data;
};

export const deleteAdminUser = async (id) => {
  const r = await adminApi.delete(`/admin/users/${id}`);
  return r.data;
};

// Invites
export const fetchAdminInvites = async () => {
  const r = await adminApi.get("/admin/invites");
  return r.data;
};

export const createAdminInvite = async ({ email, name }) => {
  const r = await adminApi.post("/admin/invites", { email, name });
  return r.data;
};

export const revokeAdminInvite = async (id) => {
  const r = await adminApi.delete(`/admin/invites/${id}`);
  return r.data;
};
